import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './container.module.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['section-padding-top', 'section-padding-below-nav', null])
};

const Container = ({children, className = '', variant = null}) => {
  const sectionClass = cx(className, styles.section, {
    [styles.section]: variant === null,
    [styles[`${variant}`]]: variant !== null
  });

  return <div className={`${styles.container} ${sectionClass} `}>{children}</div>;
};

Container.propTypes = propTypes;

export default Container;
